import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.swiper = new Swiper(this.element, {
      loop: true,
      modules: [Pagination],
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
}
